import {API} from '../API';

export class LocationService {

  async saveLocation(contact, data) {
    let method = 'post';
    let url = `contacts/${contact.id}/locations`;
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteLocation(contact, location) {
    return (await API.getConnection())
      .delete(`contacts/${contact.id}/locations/${location.id}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
